import React, { useEffect, useState } from 'react';
import { getReadinessSnapshot, listReadinessSnapshots } from '../../services/orderXApi';
import { ReadinessReportView } from './ReadinessReportView';
import { reportFromSnapshot, scoreBadgeClass, formatReadinessTimestamp } from './readinessUtils';

export function ReadinessHistory() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const data = await listReadinessSnapshots({ page: 1, page_size: 20 });
        if (!cancelled) setItems(data?.items || []);
      } catch (err) {
        if (!cancelled) setError(err?.message || 'Unable to load readiness history.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const openSnapshot = async (snapshotId) => {
    setError('');
    try {
      const snapshot = await getReadinessSnapshot(snapshotId);
      setSelected(snapshot);
    } catch (err) {
      setError(err?.message || 'Unable to load snapshot.');
    }
  };

  const selectedReport = reportFromSnapshot(selected);

  return (
    <div>
      <h5 className="mb-3">History</h5>
      {loading ? <div className="text-muted">Loading snapshots…</div> : null}
      {error ? <div className="alert alert-danger py-2">{error}</div> : null}
      <div className="row g-3">
        <div className="col-12 col-lg-5">
          <div className="list-group">
            {items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`list-group-item list-group-item-action ${selected?.id === item.id ? 'active' : ''}`}
                onClick={() => openSnapshot(item.id)}
              >
                <div className="d-flex justify-content-between align-items-start gap-2">
                  <div>
                    <div>#{item.id}</div>
                    <div className="small opacity-75">{formatReadinessTimestamp(item.created_at) || item.run_mode}</div>
                  </div>
                  <div className="d-flex flex-column align-items-end gap-1">
                    <span className={`badge ${scoreBadgeClass(item.readiness_score)}`}>{item.readiness_score}%</span>
                    {item.ready ? (
                      <span className="badge text-bg-success">Ready</span>
                    ) : (
                      <span className="badge text-bg-secondary">Not ready</span>
                    )}
                  </div>
                </div>
              </button>
            ))}
            {!loading && !items.length ? (
              <div className="list-group-item text-muted small">No snapshots yet.</div>
            ) : null}
          </div>
        </div>
        <div className="col-12 col-lg-7">
          {selected ? (
            <div className="card border">
              <div className="card-body">
                <ReadinessReportView report={selectedReport} title={`Snapshot #${selected.id}`} />
              </div>
            </div>
          ) : (
            <div className="text-muted small">Select a snapshot to inspect the saved report.</div>
          )}
        </div>
      </div>
    </div>
  );
}
